<template>
  <v-dialog v-model="dialogPackageDetail" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Lô hàng ngày {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!CorrectData" color="blue darken-1 white--text" @click="saveItem">Lưu lại (節省)</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
              <v-flex lg6 md6 sm6 pa-0 ma-0 mt-3>
                <v-checkbox label="Sử dụng máy đọc barcode (使用扫码器)" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-0 ma-0 mt-3 v-if="!currentItem.ID">
                <v-checkbox label="Nhập tất cả (輸入全部)" v-model="importAll"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 mt-0>
                <v-autocomplete v-if="!useBarcodeReader" :disabled="readOnly" label="Mã vận đơn (运单号)" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentTransaction.TransactionCode" :search-input.sync="search" class="input-group--focused" @change="manualChanged"></v-autocomplete>
                <v-text-field
                  v-else
                  label="Mã vận đơn (运单号)"
                  ref="trancode"
                  v-model="currentTransaction.TransactionCode"
                  class="input-group--focused"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                  :disabled="readOnly"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table
                  :headers="headers"
                  :items="currentItem.Packages"
                  :server-items-length="currentItem.Packages.length"
                  :items_per_page="20"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.TransactionCode }}</td>
                      <td>{{ item.Username }}</td>
                      <td class="text-right">{{ item.Weight | currency('', 2)}}</td>
                      <td class="text-right">{{ item.Volume | currency('', 3)}}</td>
                      <td class="text-center">
                        <v-icon v-if="!readOnly" small @click="deleteTransaction(item.ID)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2>
            <v-layout row wrap pl-5 pt-4>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã lô hàng (批號)"
                  :disabled="autoPackageCode"
                  v-model="currentItem.PackageCode"
                  :rules="packcodeRules"
                  class="input-group--focused"
                  @change="onChangePackageCode"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3 v-if="!storeTQRole">
                <v-autocomplete label="Khách hàng (客户)" v-model="currentItem.UID" :items="customers" :item-text="getCustomerText" item-value="ID" @change="onSelectedCustomer"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3 v-if="!storeTQRole">
                <v-autocomplete label="Chọn địa chỉ (選擇地址)" v-model="currentItem.AddressID" :items="addressBooks" :item-text="getAddressText" item-value="ID" @change="onSelectedAddress"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3 v-if="!storeTQRole">
                <v-text-field
                  label="Điện thoại (電話號碼)"
                  v-model="currentItem.PhoneNumber"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3 v-if="!storeTQRole">
                <v-text-field
                  label="Địa chỉ (地址)"
                  v-model="currentItem.Address"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Tên hàng hoá (產品名稱)"
                  v-model="currentItem.ProductName"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng mã (代碼總數)"
                  v-model="currentItem.NumberOfPack"
                  :decimal="0"
                  :disabled="readOnly"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng kiện (總包數)"
                  v-model="currentItem.TotalSmallPack"
                  :decimal="0"
                  :disabled="readOnly"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-0 pr-1 pt-3>
                <h-currency-input
                  label="Cước phí (郵資) ¥"
                  v-model="currentItem.Amount"
                  :decimal="2"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-0 pl-1 pt-3>
                <h-currency-input
                  label="Cước phí (郵資) ₫"
                  v-model="currentItem.AmountVND"
                  :decimal="0"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng cân nặng (總重量)"
                  v-model="currentItem.Weight"
                  :decimal="2"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng khối (總容積)"
                  v-model="currentItem.Volume"
                  :decimal="2"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-select
                  class="pa-0"
                  label="Kho VN (越南倉庫)"
                  :items="warehouses"
                  v-model="currentItem.ReceivePlaceID"
                  item-text="Name"
                  item-value="ID"
                  :disabled="readOnly"
                ></v-select>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-select
                  class="pa-0"
                  label="Kho nhận (收貨倉庫)"
                  :items="storeExpList"
                  v-model="currentItem.StoreExpID"
                  item-text="Name"
                  item-value="ID"
                  :disabled="readOnly"
                ></v-select>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Biển số xe (車牌)"
                  v-model="currentItem.StorePhoneNumber"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Ghi chú (筆記)"
                  v-model="currentItem.Note"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import moment from "moment";
import { getCurrentTime, sendErrorNotice, playSound } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
export default {
  name: "big-package-popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      useBarcodeReader: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      importAll: false,
      queryTerm: '',
      currentTransaction: {
        TransactionCode: ""
      },
      headers: [
        {
          text: "Mã vận đơn (运单号)",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Khách hàng (客户)",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cân nặng (總重量)",
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: dataType["Number"]
        },
        {
          text: "Số khối (總容積)",
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: dataType["Number"]
        },
        {
          text: "Thao tác (手術)",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      packcodeRules: [v => !this.autoPackageCode  && !!v || "Mã lô không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [5] },
      currentTime: getCurrentTime()
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    dialogPackageDetail() {
      if (this.dialogPackageDetail) {
        this.$nextTick(() => this.$refs.trancode.focus());
        this.getListSuggestions();
      }
    },
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    currentItem() {
      this.onSelectedCustomer();
    },
    importAll() {
      if(this.importAll) {
        this.currentItem.Packages = this.suggestItems;
      }
      else {
        this.currentItem.Packages = [];
      }
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading,
      warehouses: state => state.commons.stores,
      customers: state => state.customer.master.data,
      suggestItems: (state) => state.orderTransaction.suggestList.data,
      addressBooks: state => state.addressBook.all.data,
      storeExpList: state => state.storeExp.all.data,
    }),
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
    },
    CorrectData() {
      return this.currentItem.Packages.length > 0;
    },
    suggestList() {
      let packages = this.currentItem.Packages;
      return _.filter(this.suggestItems, function(o) {
          return packages.length == 0 || !_.find(packages, pkg => pkg.ID === o.ID)
        })
    },
    search: {
      get () {
        return this.queryTerm
      },
      
      set (searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    getListSuggestions() {
      this.$store.dispatch("orderTransaction/getListSuggest", {filter: [
        {
          column: "Status",
          value: 2,
          condition: "equal",
        }]});
    },
    filter_data: function() {
      if (this.currentItem.ID > 0) {
        var param = {
          pagination: {...this.pagination, itemsPerPage: 10000}
        };
        this.$store.dispatch("bigPackage/getDetail", {'id': this.currentItem.ID, 'param': param});
      }
      this.$store.dispatch("storeExp/getList");
    },
    deleteTransaction(id) {
      this.currentItem.Packages = _.filter(this.currentItem.Packages, pkg => pkg.ID !== id);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveItem() {
      this.onChangePackageCode();
      // const selectedStore = _.find(this.warehouses, {ID: this.currentItem.ReceivePlaceID})
      // if(selectedStore) {
      //   this.currentItem.StoreShortName = selectedStore.ShortName
      // }
      if(this.currentItem.ID > 0) {
        delete this.currentItem.Status;
        delete this.currentItem.State;
        delete this.currentItem.ImDate;
      }
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ...this.currentItem,
          'Packages': _.map(this.currentItem.Packages, "ID")
        },
        id: this.currentItem.ID
      }).then(p => {
        if(p.status == 200) {
          this.$emit("closePopup");
        }
      });
      
    },
    manualChanged() {
      this.currentTransaction.TransactionCode = this.currentTransaction.TransactionCode == '' ? this.queryTerm : this.currentTransaction.TransactionCode;
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
        var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode.trim(),
                condition: "s_equal"
            },
            {
                column: "StoreCNImportDate",
                condition: "not_null"
            },
            {
                column: "BigPackageID",
                value: 0,
                condition: "equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransaction.TransactionCode.trim()})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Gói hàng đã tồn tại.')
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            this.currentItem.Packages.unshift(ret.data[0]);
            playSound('/success.mp3');
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            sendErrorNotice('Gói hàng không tồn tại hoặc đã đóng trong lô khác.')
          }
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
        is_master: 1,
        fields: ["ID", "Username", "PhoneNumber", "Address"]
      });
    },
    onSelectedAddress() {
      const addr = _.find(this.addressBooks, {'ID': this.currentItem.AddressID});
      if(addr) {
          this.currentItem.PhoneNumber = addr.Phone;
          this.currentItem.Address = addr.Address;
      }
    },
    onSelectedCustomer() {
      this.$store.dispatch("addressBook/getList", {
        filter: [{
          column: "UID",
          value: this.currentItem.UID || 0,
          condition: "equal"
        }]
      });
    },
    onChangePackageCode() {
      const regex = /^N(\d+)-/; // ^N: bắt đầu bằng N, (\d+): lấy số, -: đến dấu -
      const match = this.currentItem.PackageCode.match(regex);
      if (match) {
        this.currentItem.UID = Number(match[1]);
        this.onSelectedCustomer();
      }
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    getAddressText(item) {
      return `${item.Receiver} - ${item.Phone}`
    },
  },
  mounted() {
    this.getCustomerList();
    this.$store.dispatch("consignment/getList");
    this.$store.dispatch("commons/getAllStores");
  }
};
</script>
